//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { CostSummaryDTO } from 'src/app/core/models/system/financial/cost-summary.dto';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { FinancialDataDTO } from 'src/app/core/models/system/financial/financialdata.dto';
import { FinancialPeriodDataDTO } from 'src/app/core/models/system/financial/financialperioddata.dto';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
//import { OurDate } from 'src/app/core/interfaces/general/our-date';

@Injectable({ providedIn: 'root' })

export class FinancialService {
  
  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getCostSummary(reportTypeIdEnc: string,
                        companyIdEncSS : string,
                        userIdEnc      : string,
                        deviceId       : number,
                        year           : number,
                        month          : number,
                        day            : number): Observable<CostSummaryDTO> {
    try {
      return this.httpClientService.get<CostSummaryDTO>(environment.eSimApi
                                                        + eSimApiPaths.Financials
                                                        + '/'
                                                        + eSimApiPaths.FinancialsCostSummary
                                                        + "?reportTypeIdEnc=" + reportTypeIdEnc
                                                        + "&companyIdEncSS="  + companyIdEncSS
                                                        + "&userIdEnc="       + userIdEnc
                                                        + "&deviceId="        + deviceId
                                                        + "&year="            + year
                                                        + "&month="           + month
                                                        + "&day="             + day);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getFinancials(reportTypeId: number, companyId: number, userId: number, deviceId: number, reportPeriod: Date): Observable<FinancialDataDTO> {
    try {
      return this.httpClientService.get<FinancialDataDTO>(environment.eSimApi +
                                                          eSimApiPaths.Financials +
                                                          "?reportTypeId=1&companyId=1&userId=535&deviceId=848&reportPeriod=null");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  // public getFinancialPeriods() {
  //   return this.httpClientService.get<FinancialPeriodDataDTO[]>(environment.eSimApi +
  //                                                               eSimApiPaths.Financials + '/' + 
  //                                                               eSimApiPaths.FinancialPeriods);
  // }

  public getFinancialReports() {
    try {
      return this.httpClientService.get<FinancialPeriodDataDTO[]>(environment.eSimApi +
                                                                  eSimApiPaths.Financials + '/' + 
                                                                  eSimApiPaths.FinancialReports);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getFinancialReportsForReseller() {
    try {
      return this.httpClientService.get<FinancialPeriodDataDTO[]>(environment.eSimApi +
                                                                  eSimApiPaths.Financials + '/' + 
                                                                  eSimApiPaths.FinancialReportsForReseller);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
